import { styled } from 'styled-components';

const PageStyled = styled.div`
    display: flex;
    background-color: white;
`;

export default PageStyled;
